import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions';
import {
  ListResultState, IdType, SortingBy, OrderBy,
} from '@rootCommon/types/common';
import { SitesListItem } from '@rootCommon/types/site';

type Action = ActionType<typeof actions>;
type OwnState = { selectedSiteId: IdType | null };
export type SitesState = ListResultState<SitesListItem> & OwnState;

const initState: SitesState = {
  data: null,
  loading: false,
  error: null,
  selectedSiteId: null,
  filter: { search: '', sorting: SortingBy.ASC, orderBy: OrderBy.CREATION_DATE },
};

export const sitesReducer = (state = initState, action: Action): SitesState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchSites.request):
      return { ...state, loading: true };
    case getType(actions.fetchSites.success):
      return { ...state, loading: false, data: { items: action.payload, total: action.payload.length } };
    case getType(actions.fetchSites.failure):
      return { ...state, loading: false, error: action.payload };

      // delete id
    case getType(actions.deleteSite.request):
      return { ...state, loading: true };
    case getType(actions.deleteSite.success): {
      const items = state.data?.items ? [...state.data.items] : [];
      const newItems = items.filter((item) => item.id !== action.payload);

      return { ...state, data: { items: newItems, total: newItems.length }, loading: false };
    }
    case getType(actions.deleteSite.failure):
      return { ...state, loading: false, error: action.payload };

      // set selected
    case getType(actions.setSelectedSiteId):
      return { ...state, selectedSiteId: action.payload };

      // filter
    case getType(actions.setSitesFilter):
      return { ...state, filter: action.payload };

      // default
    default:
      return state;
  }
};

export default sitesReducer;
